import revive_payload_client_4sVQNw7RlN from "/app/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/app/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/app/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/app/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/app/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_tbFNToZNim from "/app/node_modules/@zadigetvoltaire/nuxt-gtm/dist/runtime/plugin.mjs";
import plugin_WLsn00x1qh from "/app/node_modules/@nuxt/icon/dist/runtime/plugin.js";
import switch_locale_path_ssr_5csfIgkrBP from "/app/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/app/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import api_url_rOijwFhRZ6 from "/app/plugins/api-url.ts";
import vee_validate_KcKlKmvCrJ from "/app/plugins/vee-validate.ts";
import v_viewer_client_NzxRaeRJSx from "/app/plugins/v-viewer.client.ts";
import Vue3Lottie_client_bMZiOS6AB0 from "/app/plugins/Vue3Lottie.client.ts";
import firebase_client_zXNDa0wxFH from "/app/plugins/firebase.client.ts";
import init_store_Kj4ffxz7Vv from "/app/plugins/init-store.ts";
import socket_io_QQJt96c4g9 from "/app/plugins/socket.io.ts";
import user_store_5f6Ap932Po from "/app/plugins/user-store.ts";
import vee_toastification_CGrwawtSs9 from "/app/plugins/vee-toastification.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_tbFNToZNim,
  plugin_WLsn00x1qh,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  api_url_rOijwFhRZ6,
  vee_validate_KcKlKmvCrJ,
  v_viewer_client_NzxRaeRJSx,
  Vue3Lottie_client_bMZiOS6AB0,
  firebase_client_zXNDa0wxFH,
  init_store_Kj4ffxz7Vv,
  socket_io_QQJt96c4g9,
  user_store_5f6Ap932Po,
  vee_toastification_CGrwawtSs9
]